<template>
    <div v-if="tempProposal.locked && locked">
        <!-- <object :data="'https://drive.google.com/viewerng/viewer?embedded=true&url='+pdf" type="application/pdf" frameborder="0" width="100%" height="900px">
            <embed :src="'https://drive.google.com/viewerng/viewer?embedded=true&url='+pdf" width="100%" height="900px"/>
        </object> -->
        <iframe style="width: 100%; height:100vh" :src="pdf+'#view=FitH'" ></iframe>
    </div>
    <div v-else class="flex justify-center mt-24">

        <img width="600" src="/images/working.svg">
    </div>
</template>

<script>
import Form    from "../../utils/form";
import Swal    from 'sweetalert2';
import Preview from "./preview/preview";

export default {
    components: {Preview},
    props: ['proposal', 'signer', 'team','pdf'],
    data() {
        return {
            tempProposal: this.proposal,
            form: new Form({
                proposalToken: this.proposal.token,
                signerToken: this.signer.token,
                signed_name: null,
                i_agree: false,
            }),
            locked: true,
            ip:''
        }
    },
    mounted() {
        if (!this.tempProposal.locked) {
            this.fireErrorToast('The quote has been locked. The quote is currently \n ' +
                'being modified and cannot be signed at this time. Please check back at a later \n ' +
                'time to sign your quote. Thank you for your patience!');
        }
        this.getIPFromAmazon();
    },
    methods: {
        openSignAndAcceptModal() {
            if(this.form.signerToken == null){
                this.fireErrorToast('Please login to sign and accept the proposal.');
                setTimeout(function(){ window.location.href = "/login"; },5000);
                return false;
            }
            $("#signAndAccept").modal("show");
        },
        signAndAccept() {
            let self = this;
            this.form.post('/proposal/sign-and-accept')
                .then((response) => {
                    if (response.status === 'success') {
                        $("#signAndAccept").modal("hide");
                        window.location = response.redirect;
                    } else {
                        $("#signAndAccept").modal("hide");
                        self.fireErrorToast(response.message);
                        self.locked = false;
                    }
                });
        },
        fireErrorToast(message) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
            });

            Toast.fire({
                type: 'warning',
                title: message,
            });
        },
        getIPFromAmazon() {
            fetch('https://api.ipify.org?format=json')
                .then(x => x.json())
                .then(({ ip }) => {
                    this.ip = ip;
                    this.updateProposalView();
                });
        },
        updateProposalView(){
            axios.post('update-proposal-view', {proposal: this.proposal.id, ip:this.ip});
        }
    },
}
</script>

<style scoped>
.reports-frame-style {
    height: 100vh;
    width: 100%;
    border: 1px solid grey;
    border-radius: 7px;
}
.one-page table {
    border-collapse: collapse;
    margin: 0;
    width: 100%;
    table-layout: fixed;
    word-break: break-word;
}
.one-page table, .one-page th, .one-page td{
    border:1px solid #b9b9b9;
    padding: 2px 5px;
}
.one-page th{
    text-align: center !important;
    background-color: #f0f0f0;
}
</style>
